module.exports = __webpack_public_path__ + "static/img/clqd2.54ba2869.png";